export const announcementKeys = {
  all: ['system-announcements'],
  active: () => [...announcementKeys.all, 'active'],
  archive: () => [...announcementKeys.all, 'archive'],
  adminList: () => [...announcementKeys.all, 'admin-list'],
};
